const attachment = {
  attachment: '附件',
  'attachment.attachment': '附件',
  'attachment.accepttext': '支持xlsx/jpg/png/pdf文件上传，文件大小需小于10M',
  'attachment.errsize': '文件大小需小于10M',
  'attachment.errtype': '文件格式错误',
  'attachment.uploadfile': '上传文件',
};

export default attachment;
